import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { ArrowUp, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const { t, language } = useLanguage();

  // Logo URLs
  const logoTR = 'https://customer-assets.emergentagent.com/job_94139453-6f7a-4399-aef4-e5acc06243f4/artifacts/xea16yuo_ChatGPT%20Image%208%20Oca%202026%2013_29_22.png';
  const logoEN = 'https://customer-assets.emergentagent.com/job_94139453-6f7a-4399-aef4-e5acc06243f4/artifacts/u7xdry6v_ChatGPT%20Image%208%20Oca%202026%2013_30_27.png';

  const labels = {
    en: { quickLinks: 'Quick Links', practiceAreas: 'Practice Areas', ip: 'Intellectual Property', corporate: 'Corporate Law', realEstate: 'Real Estate Law' },
    tr: { quickLinks: 'Hızlı Erişim', practiceAreas: 'Faaliyet Alanları', ip: 'Fikri Mülkiyet Hukuku', corporate: 'Ticaret Hukuku', realEstate: 'Gayrimenkul Hukuku' },
    es: { quickLinks: 'Enlaces Rápidos', practiceAreas: 'Áreas de Práctica', ip: 'Propiedad Intelectual', corporate: 'Derecho Corporativo', realEstate: 'Derecho Inmobiliario' },
    fr: { quickLinks: 'Liens Rapides', practiceAreas: 'Domaines de Pratique', ip: 'Propriété Intellectuelle', corporate: 'Droit des Sociétés', realEstate: 'Droit Immobilier' },
  };

  const currentLabels = labels[language] || labels.en;
  const currentLogo = language === 'tr' ? logoTR : logoEN;
  const firmName = language === 'tr' ? 'HH Hukuk Bürosu' : 'HH Law Office';

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="relative bg-[#0f1f35] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Main Footer */}
        <div className="py-16 grid md:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="md:col-span-2 space-y-6">
            <img 
              src={currentLogo} 
              alt={firmName}
              className="h-16 w-auto object-contain logo-inverted"
            />
            <p className="text-blue-200 leading-relaxed max-w-md">
              {t('footer.description')}
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-blue-200">
                <Mail className="w-4 h-4" />
                <a href="mailto:info@hh-lawoffice.com" className="hover:text-white transition-colors">
                  info@hh-lawoffice.com
                </a>
              </div>
              <div className="flex items-start gap-3 text-blue-200">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                <span className="text-sm">42 Maslak Ahi Evran Caddesi No:6 Ofis 3 Kat 5 Sarıyer/İstanbul</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-6">{currentLabels.quickLinks}</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-blue-200 hover:text-white transition-colors text-sm"
                >
                  {t('nav.services')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-blue-200 hover:text-white transition-colors text-sm"
                >
                  {t('nav.about')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('blog')}
                  className="text-blue-200 hover:text-white transition-colors text-sm"
                >
                  {t('nav.blog')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-blue-200 hover:text-white transition-colors text-sm"
                >
                  {t('nav.contact')}
                </button>
              </li>
            </ul>
          </div>

          {/* Practice Areas */}
          <div>
            <h4 className="font-semibold mb-6">{currentLabels.practiceAreas}</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-blue-200 hover:text-white transition-colors text-sm"
                >
                  {currentLabels.ip}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-blue-200 hover:text-white transition-colors text-sm"
                >
                  {currentLabels.corporate}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-blue-200 hover:text-white transition-colors text-sm"
                >
                  {currentLabels.realEstate}
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-blue-200 text-sm">
            © {new Date().getFullYear()} {firmName}. {t('footer.rights')}
          </p>
          <div className="flex items-center gap-6">
            <button className="text-blue-200 hover:text-white text-sm transition-colors">
              {t('footer.privacy')}
            </button>
            <button className="text-blue-200 hover:text-white text-sm transition-colors">
              {t('footer.terms')}
            </button>
            <button
              onClick={scrollToTop}
              className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors"
            >
              <ArrowUp className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
